var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserCheck = function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77 14.136a3 3 0 0 0-.126 3.865H3.722c-1.416 0-2.223-.444-2.223-1.778 0-3.556 4.001-6.223 8-6.223 2.258 0 4.516.85 6.055 2.23l-1.39 1.824-.157-.141a3 3 0 0 0-4.237.223zM9.5 9.111a3.556 3.556 0 1 0 0-7.112 3.556 3.556 0 0 0 0 7.112zm9.528 3.508a1.004 1.004 0 0 0-1.403.189l-3.187 4.184-1.77-1.593a.999.999 0 1 0-1.338 1.486l3.384 3.045 4.503-5.91a1 1 0 0 0-.189-1.401z"
  })));
};
export default SvgUserCheck;